var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"state"}},[_c('vue-json-pretty',{attrs:{"data":_vm.state,"collapsed-on-click-brackets":"","showLength":true,"deep":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }